module.exports = __webpack_public_path__ + "static/media/oracle.71655e53.png";